// extracted by mini-css-extract-plugin
export default {"BooleanListFeature":"vv_a bhf_b"};